import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { CommonService } from 'src/app/services/common.service';
import { ConfigService } from 'src/app/services/config.service';

import { CurrencyConversionService } from 'src/app/services/currency-conversion.service';
import { formatScientificNumber } from '../utils/calsoft-validators';


@Pipe({
  name: 'currencyConvert'
})
export class CurrencyConvertPipe implements PipeTransform {

  currencyRate: any;
  countryCode: string;
  decimalDigit: any = 2;
  currencyBase: string | null = null;



  constructor(private currencyConversionService: CurrencyConversionService,
    private currencyPipe: CurrencyPipe,

    private ecryptService: EcryptServiceService
  ) {


  }

  transform(value: any, mode: 'full' | 'symbol' = 'full', isPaise: boolean = false): string | null {
    value = formatScientificNumber(value);
    // If caller requests full formatting, handle null/NaN as before
    if (mode === 'full' && (value == null || (typeof value === 'number' && isNaN(value)))) return null;



    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {


          this.countryCode = data['currencyBase'] || 'INR';




        } else {

          this.countryCode = 'INR';

        }

      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }




    const digitsInfo = `1.${this.decimalDigit}-${this.decimalDigit}`;

    // Ensure currency code is set (default to INR)
    if (!this.countryCode) {
      this.countryCode = 'INR';
    }

    // If only the symbol is required, attempt to extract it via CurrencyPipe and fallback map
    if (mode === 'symbol') {
      try {
        const formatted = this.currencyPipe.transform(0, this.countryCode, 'symbol-narrow', '1.0-0');
        if (formatted) {
          const symbol = formatted.replace(/[0-9\s,\.\u00A0\u202F\u2009\-]+/g, '').trim();
          if (symbol) return symbol;
        }
      } catch (e) {
        // ignore and fall through to fallback
      }
      return this.getFallbackSymbol(this.countryCode);
    }

    // Default: return formatted currency string
    let numericValue = Number(value);
    if (isNaN(numericValue)) return null;
    // If the value is specified to be in paise, convert to rupees
    if (isPaise) {
      numericValue = numericValue / 100;
    }
    const convertedValue = value;
    try {
      const formattedCurrency = this.currencyPipe.transform(convertedValue, this.countryCode, 'symbol-narrow', digitsInfo);
      return formattedCurrency ? formattedCurrency.replace(/(\D)(\d)/, '$1 $2') : null;
    } catch (e) {
      return `${this.countryCode} ${convertedValue}`;
    }
  }

  private getFallbackSymbol(code: string | null): string {
    switch ((code || '').toUpperCase()) {
      case 'INR': return '₹';
      case 'USD': return '$';
      case 'EUR': return '€';
      case 'GBP': return '£';
      case 'JPY': return '¥';
      default: return code || '';
    }
  }



}
